export const broadcastChannel = new BroadcastChannel('cc-broadcast-channel');
